export default function TypingPlugin() {
  return [{
    onStartTyping: function onStartTyping(event, database, next) {
      var _database$getActive = database.getActive(),
          record = _database$getActive.record,
          column = _database$getActive.column;

      if (!record) {
        return;
      }

      database.activate(record.key, column.key).focus();
      return next();
    },
    onEnter: function onEnter(event, database, next) {
      var _database$getSelectio = database.getSelection(),
          activeKey = _database$getSelectio.activeKey;

      var isFocused = database.isFocused(activeKey);

      if (!isFocused) {
        event.preventDefault();
        event.stopPropagation();
        return database.focus(activeKey);
      }

      return database.activateRecordAfter();
    }
  }];
}